import { Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

export const CardComponent = ({ title, minWidth, children }) => {
  return (
    //height: 'fit-content'
    <Card sx={{ minWidth: minWidth || 275 }}>
      <CardContent>
        <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 16, fontWeight: 600 }}>
          {title}
        </Typography>
        <Box mt={2}>{children}</Box>
      </CardContent>
    </Card>
  );
};
